<header>
	<p>
		You can browse our archive here.<br/>

		Access to the full games past the 24 hour mark is limited to
		<span class="premium-only">
			<b>premium users</b> <i class="material-icons">verified_user</i>
		</span>
	</p>
	<label class="date-selector">
		<span>Select a Date</span>
		<input type="date" [(ngModel)]="selected_date">
		<button (click)="load_date()">Go</button>
	</label>
</header>

<div class="schedule">

	@for( me of media_events_list; track me.id ){
		@let status = me.get_status_display().toLowerCase();
		@let logo = getLogoSrcOf(me.provider);
		@let game = me.game_id && games[me.game_id];
		<div class="media-event" [class]="status">
			<pre class="desc">{{ me.description }}</pre>

			<header>
				@if( logo ){
					<img class="provider-logo" [src]="logo" [alt]="me.provider"/>
				} @else {
					<span class="provider-logo">{{ me.provider }}</span>
				}
				<span class="time">{{ me.datetime | tzdate:'HH:mm (TT)' }}</span>
			</header>

			<div class="teams" *ngIf="game">
				@for( t of game.teams; track t.id; let idx = $index ){
					<app-team
						[team]="t"
						[score]="idx ? game.home_score : game.away_score"
						[is_spoilable]="game.is_spoilable()"/>
				}
			</div>

			<p class="title">{{ me.title }}</p>

			@for( f of flavors_list; track f.id ){
				<button class="flavor" *ngIf="f.media_event_ids.has(me.id)" (click)="player.assign(me, f)">
					<i class="material-icons">play_arrow</i>
					<span>{{ f.name }}</span>
				</button>
			}

			<footer class="placeholder">
				{{ me.is_playable ? "Unavailable!" : "Scheduled" }}
			</footer>

		</div>
	}

</div>
